<template>
    <v-navigation-drawer v-model="isDrawerOpen">
        <v-list>
        <v-list-item append-icon="mdi-close" @click="isDrawerOpenClick">Menu</v-list-item>
        <v-list-item prepend-icon="mdi-home" :to="{name:'home'}">Home</v-list-item>
        <v-list-group value="Áreas">
        <template v-slot:activator="{ props }">
            <v-list-item
            v-bind="props"
            prepend-icon="mdi-account-wrench"
            title="Áreas"
            ></v-list-item>
        </template>
        <v-list-item :to="{name:'areas.calibracoes'}">Calibração e Ensaios</v-list-item>
        <v-list-item :to="{name:'areas.projetos'}">Elaboração de Projetos</v-list-item>
        <v-list-item :to="{name:'engenharia.ambiental'}">Engenharia Ambiental</v-list-item>
        <v-list-item :to="{name:'engenharia.clinica'}">Engenharia Clínica</v-list-item>
        <v-list-item :to="{name:'engenharia.eletrica'}">Engenharia Elétrica</v-list-item>
        <v-list-item :to="{name:'inspecao.ultrassonica'}">Inspeção ultrassônica</v-list-item>
        <v-list-item :to="{name:'treinamento.operacional'}">Treinamento Operacional</v-list-item>
        </v-list-group>
        <v-list-item prepend-icon="mdi-home" href="http://www.engebio-ne.com.br/nuvem_facil/">Intranet</v-list-item>
        <v-list-group value="Novidade">
        <template v-slot:activator="{ props }">
            <v-list-item
            v-bind="props"
            prepend-icon="mdi-newspaper-check"
            title="Novidades"
            ></v-list-item>
        </template>
        <v-list-item prepend-icon="mdi-file-document" :to="{name:'certificados'}">certificações</v-list-item>
        </v-list-group>
        <v-list-item prepend-icon="mdi-phone" :to="{name:'contact'}">contato</v-list-item>
        <v-list-item prepend-icon="mdi-information-slab-box" :to="{name:'about'}">Sobre</v-list-item>
        </v-list>
  </v-navigation-drawer>
</template>
  
<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { mapMutations } from 'vuex';

export default {
    name:'navigation-drawer-component',
    setup() {
        const store = useStore();
        const isDrawerOpen = computed(() => {
            return store.state.isDrawerOpen;
         });
        return {
            isDrawerOpen,
        };
    },
    methods: {
    ...mapMutations(['IS_DRAWER_OPEN']),
    isDrawerOpenClick() {
      this.IS_DRAWER_OPEN();
    },
  },
}

</script>